import React, { Fragment } from "react";
import { withRouter } from "react-router-dom";
import Tabs from "@mui/material/Tabs";
import Tab from "@mui/material/Tab";
import { Box } from "@mui/material";
import excelJS from 'exceljs'
import { saveAs } from 'file-saver';
import ConstanciaAnio from "./ConstanciaAnio";
import { obtenerTodosLosDatosPredio, obtenerDatosPredio, obtenerCatalogoMaguey, obtenerTodosDescuentos } from "../../../redux/InformacionValidaDucks";
import { useDispatch, useSelector } from "react-redux";
import moment from "moment";
import { actualizarLoadingApp_true, actualizarLoadingApp_false } from '../../../redux/AppDucks'//'../../../../redux/AppDucks'
import excel from '../../../img/Excel.png'
import estilos from "./PanelRegistroPredio.module.css"
import { obtenerDatosPredioReporte } from "../../../redux/DucksUsuarioAgricola/DatosPredioDucks";
const PanelReporteExcel = () => {

  const dispatch = useDispatch();
  const fechaHoy = moment().format('YYYY-MM-DD')
  const catalogo = useSelector(store => store.InformacionValidaApi.catalogoMaguey)
  const [value, setValue] = React.useState(0);
  const [constancia, setConstancia] = React.useState(null);


  const [TipoReporte, setTipoReporte] = React.useState('');
  //filtros para reporte
  const [estado, setEstado] = React.useState(false);
  const [tipoEstado, setTipoEstado] = React.useState('');
  const [registro, setRegistro] = React.useState(false);
  const [tipoRegistro, setTipoRegistro] = React.useState('');

  const [plantas, setPlantas] = React.useState(false);
  const [TipoPlantas, setTipoPlantas] = React.useState('');
  const [nombreComun, setNombreComun] = React.useState('');
  const [nombreCientifico, setNombreCientifico] = React.useState('');
  const [fechaDescuento, setFechaDescuento] = React.useState('')

  const handleChange = (event, newValue) => {
    setValue(newValue);
  };

  React.useEffect(async () => {
    await dispatch(obtenerCatalogoMaguey())
  }, []);
  //const idPredio = (number, len) => "0".repeat(len - number.toString().length) + number.toString();

  const idPredio = (input, len) => {
    const number = parseInt(input, 10);
    const paddedNumber = number.toString().padStart(len, "0");
    return paddedNumber;
  };

  const generarReportePredios = async () => {
    await dispatch(actualizarLoadingApp_true())
    //let resultado = await dispatch(obtenerDatosPredio())
    let resultado = await dispatch(obtenerDatosPredioReporte())
    let arregloFiltro = resultado.payload
    if (tipoEstado != '') {
      arregloFiltro = arregloFiltro.filter(anexo => anexo.estado == tipoEstado)
    }
    if (tipoRegistro != '') {
      arregloFiltro = arregloFiltro.filter(anexo => anexo.tipoguia == tipoRegistro)
    }

    if (TipoPlantas != '') {
      if (TipoPlantas == 'CON PLANTAS') {
        arregloFiltro = arregloFiltro.filter(anexo => (anexo.datosmaguey = anexo.datosmaguey.filter(anexo => anexo.numeroplantas > 0)).length > 0)
      }
      if (TipoPlantas == 'SIN PLANTAS') {
        arregloFiltro = arregloFiltro.filter(anexo => (anexo.datosmaguey = anexo.datosmaguey.filter(anexo => anexo.numeroplantas == 0)).length > 0)
      }
    }
    if (nombreComun != '') {
      arregloFiltro = arregloFiltro.filter(anexo => (anexo.datosmaguey = anexo.datosmaguey.filter(anexo => anexo?.catalogomaguey?.nombrecomun == nombreComun)).length > 0)
    }
    if (nombreCientifico != '') {
      arregloFiltro = arregloFiltro.filter(anexo => (anexo.datosmaguey = anexo.datosmaguey.filter(anexo => anexo?.catalogomaguey?.catalogomagueynombrecientifico?.nombrecientifico == nombreCientifico)).length > 0)
    }
    let arreglo = []
    for (const i in arregloFiltro) {
      let { ...res } = arregloFiltro[i]
      /*  arreglo.push({
        nopredio: idPredio(res.iddatospredio, 5),
        nombrepredio: res.nombrepredio,
        nocliente: res.cliente.numerosocio,
        nombrecliente: res.cliente.nombrerazonsocial,
        nombreproductor: res.representantecampo,
        localidad: res.localidad,
        municipio: res.municipio,
        estado: res.estado,
        usufructo: res.usufructotierra,
        tenencia: res.tenenciatierra,
        superficie: res.superficiehectarea,
        longitud: res.longitudoeste,
        latitud: res.latitudnorte,
        fechaactualizacion: res.fecharegistro?.substring(0, 10),
        fecharegistro: res.fecharegistro?.substring(0, 10),
        representante: res.representantecampo,
        //
        manejo: '-----',
        comun: '-----',
        cientifico: '-----',
        existencia: '-----',
        edad: '-----',
        distanciaplantas: '-----',
        distanciasurcos: '-----',
        cantidadinicial: '-----',
        edadregistro: '-----',
      })*/

      for (const j in res.datosmaguey) {

        let { ...datomaguey } = res?.datosmaguey?.[j]
        let propietario = ''
        if (res.espropietario) propietario = res?.nombrecompletopropietario
        else propietario = res?.cliente?.nombrerazonsocial

        if (j == 0) {
          //let ordenados = await sortJSON(datomaguey?.datosmagueyhistorico, 'iddatosmagueyhistorico', 'asc');
          arreglo.push({

            //datos que se repiten 
            nopredio: idPredio(res?.iddatospredio, 5),
            nombrepredio: res?.nombrepredio,
            nocliente: res.cliente?.numerosocio,
            nombrecliente: res.cliente?.nombrerazonsocial,
            nombreproductor: propietario,
            localidad: res?.localidad,
            municipio: res?.municipio,
            estado: res?.estado,
            usufructo: res?.usufructotierra,
            tenencia: res?.tenenciatierra,
            superficie: res?.superficiehectarea,
            longitud: res?.longitudoeste,
            latitud: res?.latitudnorte,
            fecharegistro: datomaguey?.fechacreacion?.substring(0, 10),
            representante: res?.representantecampo,
            fechaactualizacion: datomaguey?.fechaactualizacion?.substring(0, 10),//ordenados[ordenados?.length - 1]?.fechacambio?.substring(0, 10),
            //Aqui termina los datos que se repiten
            manejo: datomaguey?.sistemaplantacion,
            comun: datomaguey?.catalogomaguey?.nombrecomun?.toUpperCase(),
            cientifico: datomaguey?.catalogomaguey?.catalogomagueynombrecientifico?.nombrecientifico?.toUpperCase(),
            existencia: datomaguey?.numeroplantas,
            edad: datomaguey?.edad,
            distanciaplantas: datomaguey?.distanciaplantas,
            distanciasurcos: datomaguey?.distanciasurcos,
            cantidadinicial: datomaguey?.numeroplantasregistro,
            edadregistro: datomaguey?.edad,
            tecnico: res?.nombreusuario?.toUpperCase(),
          })
        } else {
          //let ordenados = await sortJSON(datomaguey?.datosmagueyhistorico, 'iddatosmagueyhistorico', 'asc');

          arreglo.push({
            //datos que se repiten 
            nopredio: idPredio(res?.iddatospredio, 5),
            nombrepredio: res?.nombrepredio,
            nocliente: res?.cliente?.numerosocio,
            nombrecliente: res?.cliente?.nombrerazonsocial,
            nombreproductor: propietario,
            localidad: res?.localidad,
            municipio: res?.municipio,
            estado: res?.estado,
            usufructo: res?.usufructotierra,
            tenencia: res?.tenenciatierra,
            longitud: '',
            latitud: '',
            fecharegistro: datomaguey?.fechacreacion?.substring(0, 10),
            fechaactualizacion: datomaguey?.fechaactualizacion?.substring(0, 10),//ordenados[ordenados?.length - 1]?.fechacambio?.substring(0, 10),
            representante: res.representantecampo,
            //Aqui termina los datos que se repiten
            manejo: datomaguey?.sistemaplantacion,
            comun: datomaguey?.catalogomaguey?.nombrecomun?.toUpperCase(),
            cientifico: datomaguey?.catalogomaguey?.catalogomagueynombrecientifico?.nombrecientifico?.toUpperCase(),
            existencia: datomaguey?.numeroplantas,
            edad: datomaguey?.edad,
            distanciaplantas: datomaguey?.distanciaplantas,
            distanciasurcos: datomaguey?.distanciasurcos,
            cantidadinicial: datomaguey?.numeroplantasregistro,
            edadregistro: datomaguey?.edad,
            tecnico: res.nombreusuario?.toUpperCase(),
          })
        }
      }


    }
    const workbook = new excelJS.Workbook();  // Create a new workbook
    const worksheet = workbook.addWorksheet("Mis Predios"); // New Worksheet
    const path = "./files";  // Path to download excel
    // Column for data in excel. key must match data key
    worksheet.columns = [
      { header: "NO_PREDIO", key: "nopredio", width: 15 },
      { header: "NO_CLIENTE", key: "nocliente", width: 15 },
      { header: "NOMBRE DEL CLIENTE", key: "nombrecliente", width: 15 },
      { header: "NOMBRE DE PRODUCTOR", key: "nombreproductor", width: 15 },
      { header: "SITUACIÓN DE MANEJO", key: "manejo", width: 15 },
      { header: "LOCALIDAD", key: "localidad", width: 15 },
      { header: "MUNICIPIO", key: "municipio", width: 15 },
      { header: "ESTADO", key: "estado", width: 15 },
      { header: "NOMBRE DEL PREDIO", key: "nombrepredio", width: 15 },
      { header: "NOMBRE COMÚN (ESPECIE)", key: "comun", width: 15 },
      { header: "NOMBRE CIENTIFICO (ESPECIE)", key: "cientifico", width: 15 },
      { header: "EXISTENCIAS", key: "existencia", width: 15 },
      { header: "EDAD ACTUAL", key: "edad", width: 15 },
      { header: "USUFRUTO", key: "usufructo", width: 15 },
      { header: "TENENCIA", key: "tenencia", width: 15 },
      { header: "SUPERFICIE", key: "superficie", width: 15 },
      { header: "LONGITUD", key: "longitud", width: 15 },
      { header: "LATITUD", key: "latitud", width: 15 },
      { header: "DISTANCIA ENTRE PLANTAS (METROS)", key: "distanciaplantas", width: 15 },
      { header: "DISTANCIA ENTRE SURCOS (METROS)", key: "distanciasurcos", width: 15 },
      { header: "FECHA DE REGISTRO", key: "fecharegistro", width: 15 },
      { header: "REPRESENTANTE EN CAMPO", key: "representante", width: 15 },
      { header: "CANTIDAD INICIAL", key: "cantidadinicial", width: 15 },
      { header: "EDAD AL REGISTRO", key: "edadregistro", width: 15 },
      { header: "TECNICO DE CAMPO COMERCAM", key: "tecnico", width: 15 },
      { header: " FECHA DE ACTUALIZACION", key: "fechaactualizacion", width: 15 },




    ];
    ['A1', 'B1', 'C1', 'D1', 'E1', 'F1', 'G1', 'H1', 'I1', 'J1', 'K1', 'L1', 'M1', 'N1', 'O1', 'P1', 'Q1', 'R1', 'S1', 'T1', 'U1', 'V1', 'W1', 'X1', 'Y1', 'Z1'].map(key => {
      worksheet.getCell(key).fill = {
        type: 'pattern',
        pattern: 'solid',
        height: 15,
        fgColor: { argb: '68813c' }
      };
    });
    let counter = 1;
    arreglo.forEach((user) => {
      user.s_no = counter;
      worksheet.addRow(user); // Add data in worksheet
      counter++;
    });

    // Making first line in excel bold
    worksheet.getRow(1).eachCell((cell) => {
      cell.font = { bold: true };
    });
    await dispatch(actualizarLoadingApp_false())
    try {
      const buffer = await workbook.xlsx.writeBuffer();
      const fileType = 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8';
      let EXCEL_EXTENSION = '.xlsx';
      const blob = new Blob([buffer], { type: fileType });
      saveAs(blob, 'ReportePredio' + fechaHoy.substring(0, 10) + EXCEL_EXTENSION);
    } catch (err) {
      console.log("error ", err)
    }
    await dispatch(actualizarLoadingApp_false())
  }

  const generarReporteDescuentos = async () => {
    await dispatch(actualizarLoadingApp_true())
    let resultado = await dispatch(obtenerTodosDescuentos())
    let arreglo = []
    if (fechaDescuento != '') {
      let filtro = resultado.payload.filter(anexo => moment(anexo.fechadescuento).add(1, 'd').format('YYYY-MM-DD') == fechaDescuento)
      let ordenados = await sortJSON(filtro, 'iddescuento', 'asc');
      for (const i in ordenados) {
        let { ...datos } = ordenados[i]
        arreglo.push({
          nopredio: idPredio(datos.datosmaguey.iddatospredio, 5),
          nombrepredio: datos.datosmaguey.datospredio.nombrepredio,
          nocliente: datos.datosmaguey.datospredio.cliente.numerosocio,
          nombrecliente: datos.datosmaguey.datospredio.cliente.nombrerazonsocial,
          numeroguia: datos.identificador,
          fechadecuento: moment(datos.fechadescuento).add(1, 'd').format('YYYY-MM-DD'),
          tapada: datos.tapada,
          inspector: datos.inspector?.toUpperCase(),
          receptorguia: datos.receptor,
          especie: datos.datosmaguey.catalogomaguey.catalogomagueynombrecientifico.nombrecientifico?.toUpperCase(),
          comun: datos.datosmaguey.catalogomaguey.nombrecomun?.toUpperCase(),
          edad: datos.datosmaguey.edad,
          descuento: datos.descuento,
          kgvariedad: datos.kgvariedad,
        })
      }
    } else {
      let ordenados = await sortJSON(resultado.payload, 'iddescuento', 'asc');
      for (const i in ordenados) {
        let { ...datos } = ordenados[i]
        arreglo.push({
          nopredio: idPredio(datos.datosmaguey.iddatospredio, 5),
          nombrepredio: datos.datosmaguey.datospredio.nombrepredio,
          nocliente: datos.datosmaguey.datospredio.cliente.numerosocio,
          nombrecliente: datos.datosmaguey.datospredio.cliente.nombrerazonsocial,
          numeroguia: datos.identificador,
          fechadecuento: moment(datos.fechadescuento).add(1, 'd').format('YYYY-MM-DD'),
          tapada: datos.tapada,
          inspector: datos.inspector?.toUpperCase(),
          receptorguia: datos.receptor,
          especie: datos.datosmaguey.catalogomaguey.catalogomagueynombrecientifico.nombrecientifico?.toUpperCase(),
          comun: datos.datosmaguey.catalogomaguey.nombrecomun?.toUpperCase(),
          edad: datos.datosmaguey.edad,
          descuento: datos.descuento,
          kgvariedad: datos.kgvariedad,
        })
      }
    }
    const workbook = new excelJS.Workbook();  // Create a new workbook
    const worksheet = workbook.addWorksheet("Mis Descuentos"); // New Worksheet
    const path = "./files";  // Path to download excel
    // Column for data in excel. key must match data key
    worksheet.columns = [
      { header: "NO_PREDIO", key: "nopredio", width: 20 },
      { header: "NOMBRE DEL PREDIO", key: "nombrepredio", width: 20 },
      { header: "NO_CLIENTE", key: "nocliente", width: 20 },
      { header: "NOMBRE DEL CLIENTE", key: "nombrecliente", width: 20 },
      { header: "IDENTIFICADOR", key: "numeroguia", width: 20 },
      { header: "FECHA DESCUENTO", key: "fechadecuento", width: 20 },
      { header: "TAPADA", key: "tapada", width: 20 },
      { header: "INSPECTOR", key: "inspector", width: 20 },
      { header: "RECEPTOR DE GUIA", key: "receptorguia", width: 20 },
      { header: "ESPECIE", key: "especie", width: 20 },
      { header: "COMUN", key: "comun", width: 20 },
      { header: "EDAD", key: "edad", width: 20 },
      { header: "DESCUENTO", key: "descuento", width: 20 },
      { header: "KG POR VARIEDAD", key: "kgvariedad", width: 20 },
    ];
    ['A1', 'B1', 'C1', 'D1', 'E1', 'F1', 'G1', 'H1', 'I1', 'J1', 'K1', 'L1', 'M1', 'N1'].map(key => {
      worksheet.getCell(key).fill = {
        type: 'pattern',
        pattern: 'solid',
        height: 15,
        fgColor: { argb: '68813c' }
      };
    });
    let counter = 1;
    arreglo.forEach((user) => {
      user.s_no = counter;
      worksheet.addRow(user); // Add data in worksheet
      counter++;
    });
    // Making first line in excel bold
    worksheet.getRow(1).eachCell((cell) => {
      cell.font = { bold: true };
    });
    await dispatch(actualizarLoadingApp_false())
    try {
      const buffer = await workbook.xlsx.writeBuffer();
      const fileType = 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8';
      let EXCEL_EXTENSION = '.xlsx';
      const blob = new Blob([buffer], { type: fileType });
      saveAs(blob, 'ReporteDescuentos' + fechaHoy.substring(0, 10) + EXCEL_EXTENSION);
    } catch (err) {
      await dispatch(actualizarLoadingApp_false())
      console.log("error ", err)
    }
  }
  function sortJSON(data, key, orden) {
    return data.sort(function (a, b) {
      var x = a[key],
        y = b[key];

      if (orden === 'asc') {
        return ((x < y) ? -1 : ((x > y) ? 1 : 0));
      }

      if (orden === 'desc') {
        return ((x > y) ? -1 : ((x < y) ? 1 : 0));
      }
    });
  }
  return (
    <Fragment>
      <br />
      <h4 className="text-center">Generación de Reportes</h4><br />
      <div className="container text-center">
        <div className="row text-center" >
          <div className={`col-3 text-center`}></div>
          <div className={`col-6 text-center`}>
            <div className="form-floating mb-3">
              <select className={`form-control`}
                value={TipoReporte} onChange={e => setTipoReporte(e.target.value)}
                id="floatingInput" >
                <option value="">Seleccione una opción</option>
                <option value={`predios`}>REPORTE DE PREDIOS</option>
                <option value={`descuentos`}>REPORTE DE DESCUENTOS</option>
              </select>
              <label className="floatingInput">Tipo de reporte</label>
            </div>
          </div>
        </div>
        {TipoReporte == 'predios' &&
          <div className={`row text-center ${estilos.divSoloBorderNaranja}`}>

            <div className={`${estilos.labelEspecial} col-md-12 mb-3 text-center`}><h5>Filtros</h5></div>
            {/*<div className='col-md-6 text-start'>
              <input className={`form-check-input me-1 `} type="checkbox"
                checked={estado} id='estado' name="estado" onChange={e => { setEstado(e.target.checked) }} />
              <label className="form-check-label me-1" htmlFor="flexCheckChecked"> Estado </label><br />
            </div>*/}

            <div className='col-md-4'>
              <div className="form-floating mb-3">
                <select className={`form-control`} value={tipoEstado} onChange={e => setTipoEstado(e.target.value)} id="floatingInput" >
                  <option value="">Seleccione una opción</option>
                  <option value={`OAXACA`}>OAXACA</option>
                  <option value={`GUERRERO`}>GUERRERO</option>
                  <option value={`SAN LUIS POTOSÍ`}>SAN LUIS POTOSÍ</option>
                  <option value={`ZACATECAS`}>ZACATECAS</option>
                  <option value={`DURANGO`}>DURANGO</option>
                  <option value={`TAMAULIPAS`}>TAMAULIPAS</option>
                  <option value={`GUANAJUATO`}>GUANAJUATO</option>
                  <option value={`MICHOACÁN DE OCAMPO`}>MICHOACÁN DE OCAMPO</option>
                  <option value={`PUEBLA`}>PUEBLA</option>
                </select>
                <label className="floatingInput">Seleccione el estado</label>
              </div>
            </div>

            {/*<div className='col-md-6 mt-3 text-start'>
              <input className={`form-check-input me-1 `} type="checkbox" checked={registro} onChange={e => { setRegistro(e.target.checked) }} />
              <label className="form-check-label me-1" htmlFor="flexCheckChecked"> Tipo registro </label><br />
            </div>*/}
            <div className='col-md-4'>
              <div className="form-floating mb-3">
                <select className={`form-control`} value={tipoRegistro} onChange={e => setTipoRegistro(e.target.value)} id="floatingInput" >
                  <option value="">Seleccione una opción</option>
                  <option value={`NORMAL`}>NORMAL</option>
                  <option value={`EXTEMPORÁNEO`}>EXTEMPORÁNEO</option>
                </select>
                <label className="floatingInput">Seleccione el tipo de registro</label>
              </div>
            </div>

            {/*<div className='col-md-6 mt-3 text-start'>
              <input className={`form-check-input me-1 `} type="checkbox" checked={plantas} onChange={e => { setPlantas(e.target.checked) }} />
              <label className="form-check-label me-1" htmlFor="flexCheckChecked"> Número de plantas </label><br />
            </div>*/}
            <div className='col-md-4'>
              <div className="form-floating mb-3">
                <select className={`form-control`} value={TipoPlantas} onChange={e => setTipoPlantas(e.target.value)} id="floatingInput" >
                  <option value="">Seleccione una opción</option>
                  <option value={`CON PLANTAS`}>CON PLANTAS</option>
                  <option value={`SIN PLANTAS`}>SIN PLANTAS</option>
                </select>
                <label className="floatingInput">Seleccione el tipo de existencia</label>
              </div>
            </div>
            <div className='col-md-6'>
              <div className="form-floating mb-3">
                <select className={`form-control`} value={nombreComun} onChange={e => setNombreComun(e.target.value)} id="floatingInput" >
                  <option value="">Seleccione una opción</option>
                  {catalogo?.map((nombre, index) => (
                    <option key={index} value={`${nombre?.nombrecomun}`}>{`${nombre?.nombrecomun}`}</option>))
                  }
                </select>
                <label className="floatingInput">Seleccione el nombre comun</label>
              </div>
            </div>
            <div className='col-md-6'>
              <div className="form-floating mb-3">
                <select className={`form-control`} value={nombreCientifico} onChange={e => setNombreCientifico(e.target.value)} id="floatingInput" >
                  <option value="">Seleccione una opción</option>
                  {catalogo?.map((nombre, index) => (
                    <option key={index} value={`${nombre?.catalogomagueynombrecientifico?.nombrecientifico}`}>{`${nombre?.catalogomagueynombrecientifico?.nombrecientifico}`}</option>))
                  }
                </select>
                <label className="floatingInput">Seleccione el nombre cientifico</label>
              </div>
            </div>
            <div className='col-md-5'>  </div>
            <div className='col-2'>
              <button onClick={e => generarReportePredios()}
                style={{ borderRadius: '6px', padding: '10px', marginLeft: '5%' }}
                className='btn-success' >{/*<img src={excel} style={{ width: '80px' }}></img>*/}Generar reporte
              </button>
            </div>

          </div>
        }
        {TipoReporte == 'descuentos' &&
          <div className={`row text-center ${estilos.divSoloBorderNaranja}`}>

            <div className={`${estilos.labelEspecial} col-md-12 mb-3 text-center`}><h5>Filtros</h5></div>
            <div className="form-floating col-md-6">
              <input type="date" className={`form-control`} id="floatinginput" placeholder='Inicio'
                value={fechaDescuento} onChange={e => setFechaDescuento(e.target.value)} max={fechaHoy} />
              <label htmlFor="floatingInput"> Fecha Descuento</label>
            </div>

            <div className='col-md-2'>  </div>
            <div className='col-2' >
              <button onClick={e => generarReporteDescuentos()}
                style={{ borderRadius: '6px', padding: '10px', marginLeft: '5%' }}
                className='btn-success' >{/*<img src={excel} style={{ width: '80px' }}></img>*/}Generar reporte
              </button>
            </div>

          </div>
        }



      </div>

    </Fragment>
  );
}

export default withRouter(PanelReporteExcel)